"use client";
import { jsx as e } from "react/jsx-runtime";
import { forwardRef as f, createElement as p } from "react";
import d from "../../layout/Container/Container.js";
import c from "../../layout/Section/Section.js";
import { Grid as u, sharedHandler as h } from "@ingeniorforeningen/figurine-core";
import y from "../../elements/BenefitCard/BenefitCard.js";
import { benefitsDeliveryApiParser as x } from "./Benefits.helpers.js";
import { withCmsDataHandling as B } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
const r = f((t, n) => {
  const { items: o, header: a, link: m, ...s } = t;
  return /* @__PURE__ */ e(d, { ...s, ref: n, size: "xl", children: /* @__PURE__ */ e(c, { link: m, header: a, children: /* @__PURE__ */ e(u, { container: !0, columns: "repeat(auto-fill, minmax(15.625em, 1fr))", spacing: "xl", children: o.map((i, l) => /* @__PURE__ */ p(y, { ...i, fluid: !0, key: i.header + l })) }) }) });
});
r.displayName = "Benefits";
const C = B({
  Component: h(r),
  deliveryApiParser: x
});
C.displayName = r.displayName;
export {
  r as _Benefits,
  C as default
};
